import { render, staticRenderFns } from "./ModalChatUser.vue?vue&type=template&id=8504c810&scoped=true"
import script from "./ModalChatUser.vue?vue&type=script&lang=js"
export * from "./ModalChatUser.vue?vue&type=script&lang=js"
import style0 from "./ModalChatUser.vue?vue&type=style&index=0&id=8504c810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8504c810",
  null
  
)

export default component.exports